(function () {
  // Alle bekannten Rabattcodes + ihre %-Werte werden hier gecacht.
  // Shopify liefert den %-Wert automatisch beim ersten Artikel im Warenkorb.
  // Danach ist er dauerhaft gespeichert – kein manuelles Eintragen nötig.
  var CACHE_KEY = 'ss_discount_cache'; // { "JESS": 10, "SAVE20": 20, ... }
  var ACTIVE_KEY = 'ss_active_code';   // aktuell aktiver Code

  // Bekannte Codes mit festem %-Wert (sofort verfügbar, kein Warenkorb nötig)
  var KNOWN_CODES = { 'MARINA': 50, 'STEFFI50': 50, 'FRANZI50': 50, 'YASMIN50': 50, 'BUCH': 40, 'NANA': 50, 'HERO40': 40, 'KIM': 30, 'JULI': 60, 'NELLI': 30, 'SCHNEIDER': 30, 'BODY70': 70, 'SCHLUSS70': 70, 'MAMUSCHKA50': 50, 'SCHLUSS80': 80 };

  // ── Cache ────────────────────────────────────────────────────────────────
  function loadCache() {
    try {
      var stored = JSON.parse(localStorage.getItem(CACHE_KEY)) || {};
      // KNOWN_CODES haben immer Vorrang (überschreiben veraltete Cache-Werte)
      for (var k in KNOWN_CODES) { stored[k] = KNOWN_CODES[k]; }
      return stored;
    } catch(e) { return KNOWN_CODES; }
  }
  function saveCache(obj) { try { localStorage.setItem(CACHE_KEY, JSON.stringify(obj)); } catch(e) {} }
  function saveActive(code) { try { localStorage.setItem(ACTIVE_KEY, code); } catch(e) {} }
  function loadActive() { try { return localStorage.getItem(ACTIVE_KEY) || null; } catch(e) { return null; } }

  // ── Aktiven Discount zusammenstellen ────────────────────────────────────
  function getDiscount(code) {
    if (!code) return null;
    var cache = loadCache();
    var pct = cache[code];
    return pct
      ? { code: code, type: 'percentage', value: pct }
      : { code: code, type: null, value: null };
  }

  // ── Code aus URL lesen ───────────────────────────────────────────────────
  function getCodeFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search);
      var c = p.get('discount') || p.get('ref') || p.get('code');
      if (c) return c.toUpperCase().trim();
      // UTM-Campaign → Rabattcode Mapping
      var utmCampaign = p.get('utm_campaign') || '';
      var utmMap = { 'nana_creator': 'NANA', 'musselin': 'MUSSELIN' };
      for (var k in utmMap) { if (utmCampaign.toLowerCase().indexOf(k) !== -1) return utmMap[k]; }
      var m = window.location.pathname.match(/\/discount\/([^/?&#]+)/i); if (m) return decodeURIComponent(m[1]).toUpperCase().trim();
      var r = document.referrer; if (r) { var rm = r.match(/\/discount\/([^/?&#]+)/i); if (rm) return decodeURIComponent(rm[1]).toUpperCase().trim(); }
    } catch(e) {}
    return null;
  }

  // ── Code auf Cart anwenden ───────────────────────────────────────────────
  function applyToCart(code) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(function(){});
  }

  // ── %-Wert aus Cart-Daten lesen und cachen ───────────────────────────────
  function learnFromCartData(cartData) {
    var apps = (cartData && cartData.cart_level_discount_applications) || [];
    if (apps.length === 0) return null;
    var a = apps[0];
    if (a.value_type !== 'percentage') return null;
    var code = a.title.toUpperCase();
    var pct  = parseFloat(a.value);
    // In den dauerhaften Cache schreiben
    var cache = loadCache();
    cache[code] = pct;
    saveCache(cache);
    return { code: code, type: 'percentage', value: pct };
  }

  // ── Banner oben ──────────────────────────────────────────────────────────
  function showBanner(discount) {
    var old = document.getElementById('ss-discount-banner');
    if (old) old.remove();
    var bar = document.createElement('div');
    bar.id = 'ss-discount-banner';
    var txt;
    if (discount.code === '2FREE') {
      txt = '🎁 Dein Rabattcode <strong>2FREE</strong> ist aktiv! Kaufe 2 Artikel &amp; erhalte <strong>50% Rabatt</strong>.';
    } else if (discount.code === 'MARINA') {
      txt = '🏷️ Dein Rabattcode <strong>MARINA</strong> (-50%) ist aktiv!';
    } else if (discount.code === 'STEFFI50') {
      txt = '🏷️ Dein Rabattcode <strong>STEFFI50</strong> (-50%) ist aktiv!';
    } else if (discount.code === 'FRANZI50') {
      txt = '🏷️ Dein Rabattcode <strong>FRANZI50</strong> (-50%) ist aktiv!';
    } else if (discount.code === 'NANA') {
      txt = '🏷️ Dein Rabattcode <strong>NANA</strong> (-50%) ist aktiv!';
    } else if (discount.code === 'HERO40') {
      txt = '🏷️ Dein Rabattcode <strong>HERO40</strong> (-40%) ist aktiv!';
    } else if (discount.code === 'KIM') {
      txt = '🏷️ Dein Rabattcode <strong>KIM</strong> (-30%) ist aktiv!';
    } else if (discount.code === 'JULI') {
      txt = '🏷️ Dein Rabattcode <strong>JULI</strong> (-60%) ist aktiv!';
    } else if (discount.code === 'NELLI') {
      txt = '🏷️ Dein Rabattcode <strong>NELLI</strong> (-30%) ist aktiv!';
    } else if (discount.code === 'SCHNEIDER') {
      txt = '🏷️ Dein Rabattcode <strong>SCHNEIDER</strong> (-30%) ist aktiv!';
    } else if (discount.code === 'BODY70') {
      txt = '🏷️ Dein Rabattcode <strong>BODY70</strong> (-70%) ist aktiv!';
    } else if (discount.code === 'SCHLUSS70') {
      txt = '🏷️ Dein Rabattcode <strong>SCHLUSS70</strong> (-70%) ist aktiv!';
    } else if (discount.code === 'MAMUSCHKA50') {
      txt = '🏷️ Dein Rabattcode <strong>MAMUSCHKA50</strong> (-50%) ist aktiv!';
    } else if (discount.code === 'SCHLUSS80') {
      txt = '🏷️ Dein Rabattcode <strong>SCHLUSS80</strong> (-80%) ist aktiv!';
    } else if (discount.code === 'NELLI') {
      txt = '🏷️ Dein Rabattcode <strong>NELLI</strong> (-30%) ist aktiv!';
    } else if (discount.code === 'SCHNEIDER') {
      txt = '🏷️ Dein Rabattcode <strong>SCHNEIDER</strong> (-30%) ist aktiv!';
    } else if (discount.code === 'YASMIN50') {
      txt = '🏷️ Dein Rabattcode <strong>YASMIN50</strong> (-50%) ist aktiv!';
    } else if (discount.code === 'BUCH') {
      txt = '🏷️ Dein Rabattcode <strong>BUCH</strong> (-40%) ist aktiv!';
    } else if (discount.code === 'JUNI') {
      txt = 'Dein Rabattcode <strong>JUNI</strong> (-60%) ist aktiv!<br>Gilt ab 4 Artikeln im Warenkorb.';
    } else {
      txt = 'Dein Rabattcode <strong>' + discount.code + '</strong>';
      if (discount.value) txt += ' (-' + Math.round(discount.value) + '%)';
      txt += ' ist aktiv!';
    }
    bar.innerHTML =
      '<span style="flex:1;text-align:center;">'
      + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="vertical-align:middle;margin-right:4px;flex-shrink:0"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
      + txt
      + '</span>'
      + '<button onclick="this.parentElement.remove()" style="flex-shrink:0;background:none;border:none;cursor:pointer;color:inherit;font-size:1.2rem;padding:0 4px;">&times;</button>';
    document.body.insertAdjacentElement('afterbegin', bar);
  }

  // ── Preis parsen: "€27,99" oder "€27.99" → 27.99 ────────────────────────
  function parsePrice(text) {
    var t = (text || '').replace(/[^0-9,.]/g, '');
    if (/,\d{1,2}$/.test(t)) return parseFloat(t.replace(/\./g, '').replace(',', '.')) || 0;
    return parseFloat(t.replace(',', '.')) || 0;
  }

  // ── Alle Produktkarten aktualisieren ────────────────────────────────────
  function updatePrices(discount) {
    if (!discount || !discount.code) return;
    if (/\/(cart|checkout)(\/|$)/i.test(window.location.pathname)) return;
    if (discount.type !== 'percentage' || !(discount.value > 0)) return;

    var pct = discount.value;

    document.querySelectorAll('price-list').forEach(function (list) {
      var inCart = !!list.closest('cart-items, sticky-cart, mini-cart') || list.getAttribute('data-cart-item') === 'true';
      if (inCart) return;

      var saleEl = list.querySelector('sale-price');
      if (!saleEl) return;

      // Preis bestimmen: data-price-cents (neu) oder Text-Parsing (Fallback)
      var origEuros, withCurrency;
      var priceCents = parseInt(saleEl.getAttribute('data-price-cents'));
      if (priceCents > 0) {
        origEuros    = priceCents / 100;
        withCurrency = saleEl.getAttribute('data-currency-enabled') === 'true';
      } else {
        // Fallback: Preis aus sichtbarem Text lesen
        var origText = '';
        if (saleEl.getAttribute('data-orig-price')) {
          origText = saleEl.getAttribute('data-orig-price');
        } else {
          for (var i = 0; i < saleEl.childNodes.length; i++) {
            var n = saleEl.childNodes[i];
            if (n.nodeType === 3) { origText += n.textContent; }
            else if (n.nodeType === 1 && !(n.getAttribute('class') || '').includes('sr-only')) {
              origText += n.textContent;
            }
          }
          origText = origText.trim();
          if (origText) saleEl.setAttribute('data-orig-price', origText);
        }
        origEuros    = parsePrice(origText);
        withCurrency = origText.indexOf('EUR') !== -1;
      }

      if (!origEuros || origEuros <= 0) return;

      var reducedEuros = origEuros * (1 - pct / 100);
      var redTxt  = '€' + reducedEuros.toFixed(2).replace('.', ',') + (withCurrency ? ' EUR' : '');
      var origTxt = '€' + origEuros.toFixed(2).replace('.', ',')    + (withCurrency ? ' EUR' : '');

      // Preis nur einmal setzen
      if (!saleEl.getAttribute('data-dc-set')) {
        saleEl.setAttribute('data-dc-set', '1');

        // Durchgestrichener Originalpreis
        var cmpEl = list.querySelector('compare-at-price');
        if (!cmpEl) {
          cmpEl = document.createElement('compare-at-price');
          cmpEl.className = 'text-subdued line-through';
          saleEl.insertAdjacentElement('afterend', cmpEl);
        }
        if (!cmpEl.getAttribute('data-dc-orig')) {
          cmpEl.setAttribute('data-dc-orig', '1');
          cmpEl.textContent = origTxt;
        }

        // Rabattpreis anzeigen
        var sr = saleEl.querySelector('.sr-only');
        saleEl.innerHTML = (sr ? sr.outerHTML : '') + redTxt;
        saleEl.classList.add('text-on-sale');
      }

      // Badge
      if (!list.querySelector('[data-dc-badge]')) {
        var nb = document.createElement('span');
        nb.className = 'discount-auto-badge';
        nb.setAttribute('data-dc-badge', '1');
        nb.innerHTML =
          '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="display:inline-block;vertical-align:middle;margin-right:3px"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
          + '-' + Math.round(pct) + '% (' + discount.code + ')';
        list.appendChild(nb);
      }
    });
  }

  // ── MutationObserver für dynamisch geladene Produkte ────────────────────
  var _obs = null;
  function watchDOM(discount) {
    if (_obs) _obs.disconnect();
    if (!window.MutationObserver) return;
    var t;
    _obs = new MutationObserver(function() {
      clearTimeout(t);
      t = setTimeout(function() { updatePrices(discount); }, 200);
    });
    _obs.observe(document.body, { childList: true, subtree: true });
  }

  // ── Hauptlogik ───────────────────────────────────────────────────────────
  function run() {
    var urlCode = getCodeFromUrl();
    if (urlCode) {
      saveActive(urlCode);
      applyToCart(urlCode);
    }

    var code = loadActive();
    if (!code) return;

    var discount = getDiscount(code);
    showBanner(discount);
    updatePrices(discount);
    watchDOM(discount);

    // % aus Warenkorb nachladen falls noch nicht bekannt
    if (!discount.value) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var d = learnFromCartData(cart);
          if (d && d.code === code) {
            showBanner(d);
            updatePrices(d);
            watchDOM(d);
          }
        }).catch(function(){});
    }
  }

  // ── cart:change → % von Shopify automatisch lernen ──────────────────────
  document.addEventListener('cart:change', function(e) {
    var cartData = e.detail && e.detail.cart;

    function applyDiscount(d) {
      if (!d) return;
      saveActive(d.code);
      showBanner(d);
      updatePrices(d);
      watchDOM(d);
    }

    if (cartData) {
      applyDiscount(learnFromCartData(cartData));
    } else {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        applyDiscount(learnFromCartData(cart));
      }).catch(function(){});
    }
  });

  // ── Beim Seitenload Cart prüfen ob ein Discount aktiv ist ────────────────
  function checkCartForDiscount() {
    // Immer cart prüfen um manuell eingegebene Codes zu erkennen
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var d = learnFromCartData(cart);
      if (d) { saveActive(d.code); showBanner(d); updatePrices(d); watchDOM(d); return; }
      // Auch discount_codes Feld prüfen (funktioniert auch bei leerem Warenkorb)
      var codes = cart.discount_codes || [];
      if (codes.length > 0) {
        var code = codes[0].code ? codes[0].code.toUpperCase() : codes[0].toUpperCase();
        var cache = loadCache();
        if (code) {
          var discount = cache[code]
            ? { code: code, type: 'percentage', value: cache[code] }
            : { code: code, type: null, value: null };
          saveActive(code);
          showBanner(discount);
          updatePrices(discount);
          watchDOM(discount);
        }
      }
    }).catch(function(){});
  }

  // Variantenwechsel
  document.addEventListener('variant:changed', function() {
    var code = loadActive();
    if (code) setTimeout(function() { updatePrices(getDiscount(code)); }, 200);
  });


  // Rabattcode-Formular im Warenkorb beobachten
  document.addEventListener("submit", function(e) {
    var form = e.target;
    if (!form) return;
    var input = form.querySelector("input[name='discount'], input[name='checkout[discount_code]']");
    if (!input) return;
    setTimeout(function() {
      fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
        var d = learnFromCartData(cart);
        if (d) { saveActive(d.code); showBanner(d); updatePrices(d); watchDOM(d); }
        else {
          // Code wurde entfernt
          try { localStorage.removeItem("ss_active_code"); } catch(e) {}
          var old = document.getElementById("ss-discount-banner"); if (old) old.remove();
        }
      }).catch(function(){});
    }, 800);
  });
  // Browser-Zurück-Button (bfcache)
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) setTimeout(run, 50);
  });

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { run(); checkCartForDiscount(); });
  } else {
    run();
    checkCartForDiscount();
  }
})();
